import React from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from '../../../common/transform';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Nav from './nav';
import Content from './content';
import Past from './past';
import Footer from '@ifeng-fe/container_content/common/client/components/footer';
import LazyLoad from '@ifeng-fe/ui_pc_lazyLoad';
import { Comment } from 'ThreeTerminal_pc_dynamic';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;
        const { noAd, logo, domain, breadCrumbdata, title, newsTime, nextSlide, url, commentUrl, skey, subscribe } = content.docData;
        const { columnLogo, slideData, pastItems, footer } = content;
        const logoData = { logo, domain, breadCrumbdata };
        const titleData = { columnLogo, title, newsTime, subscribe };
        const contentData = { titleData, slideData, nextSlide };
        const commentDomain = typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__ : 'c01049em.ifeng.com';
        const commentConfig = {
            noAd,
            // 文章单页的页面地址
            docUrl: commentUrl,
            // 文章的标题
            docTitle: title,
            // 文章评论的skey，这个是在后端生成好后给到前端的
            skey,
            // 兼容以后的专题评论
            speUrl: '',
            // 文章pc的页面地址
            pcUrl: url,
            // 获取评论内容接口
            cmtNumUrl: `//${ commentDomain }/get.php`,
            // 评论内容字数长度
            cmtLength: 1000,
            // 提交评论内容接口
            cmtPostUrl: `//${ commentDomain }/post.php`,
            // 最热评论数量
            hotLimit: 2,
            // 推荐评论接口
            cmtVoteUrl: `//${ commentDomain }/vote.php`,
            // 现实回复的楼层
            replyLimit: 3,
            // 举报提交接口
            jubUrl: `//${ commentDomain }/report`,
            // 举报次数，便于每次回调函数名不同
            jubNum: 0,
            // 是否是评论详情页面
            isComment: false,
            order: 'both', // 'uptimes' 按热度排序，'create_time' 按时间排序， 'both', 两者同时存在
            options: 1, // 0 先显示最新，后显示最热，1 反之，此配置在 order 是 both 的情况下才生效
            recentLimit: 2, // 最近评论数量
            recentReplyLimit: 3, // 最近评论数量显示回复的楼层
        };

        return (
            <div className={styles.mainBody}>
                {/* nav */}
                <Nav content={logoData} />
                {/* content : title slide*/}
                <Content content={contentData} />
                {/* comment, past */}
                <div className={styles.cmt_past}>
                    <div className={styles.cmtBox}>
                        <LazyLoad>
                            <Comment articleInfo={commentConfig} />
                        </LazyLoad>
                    </div>
                    <Chip id='287609' type='recommend' title='往期推荐' groupName='往期推荐' content={pastItems}>
                        <Past />
                    </Chip>
                </div>
                {/* footer */}
                <div className={styles.footer}>
                    <Footer content={footer} />
                </div>
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
